import { render, staticRenderFns } from "./editPwd.vue?vue&type=template&id=6bd0dc14&scoped=true&"
import script from "./editPwd.vue?vue&type=script&lang=js&"
export * from "./editPwd.vue?vue&type=script&lang=js&"
import style0 from "./editPwd.vue?vue&type=style&index=0&id=6bd0dc14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd0dc14",
  null
  
)

export default component.exports